import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import KnowMoreArrowIcon from 'assets/images/home/know-more-arrow.svg';

const { Link, Text } = Typography;
type NewsCardProps = {
  url?: string;
  target?: string;
};
const KnowMoreLink = styled(Link)`
  display: flex;
  margin: 8px 0;
`;

const KnowMoreLinkText = styled(Text)`
  font-weight: 700;
  color: #c21b17;
  white-space: nowrap;
  letter-spacing: 1px;
`;

const KnowMoreLinkImage = styled.img`
  margin-left: 13px;
  width: 12px;
  height: 12px;
  margin-top: 5px;
`;

const NewsCard = ({ url, target }: NewsCardProps) => {
  const { t } = useTranslation();
  return (
    <KnowMoreLink href={url ? url : '#'} target={target || '_blank'}>
      <KnowMoreLinkText>{t('life.home.viewmore')}</KnowMoreLinkText>
      <KnowMoreLinkImage src={KnowMoreArrowIcon} alt="know-more-arrow" />
    </KnowMoreLink>
  );
};

export default NewsCard;
